import React, { FC, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import ErrorMessage from '@minecraft.error-message';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts, useDrawerGlobalLoader } from '@minecraft.drawer';
import {
  FormItem,
  useFiltersLabel,
  FiltersNameEnum,
  generateSelectOptionsBasedOnField,
  FilterDrawerType,
} from '@blocs.filter';
import { FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';
import { HairStyle } from '../../FilterDrawerCollection';
import { QUERY_HAIR_STYLES } from './HairLengthStyleCategoryGraphQL';

interface Props {
  type: FilterDrawerType;
}

const HairLengthStyleCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { data, error, loading } = useQuery(QUERY_HAIR_STYLES);

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.hairLengthStyle
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const hairStyleOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(data?.hairStyles, 'name'),
      'name',
      false,
      filtersCounts?.[FiltersCountNameEnum.hairStyleId]
    );
  }, [data, filtersCounts]);

  useDrawerGlobalLoader(loading);

  useEffect(() => {
    if (hairStyleOptions.length > 0) {
      assignOptionsToCategoryFilters({
        [FiltersNameEnum.hairStyle]: hairStyleOptions,
      });
    }
  }, [hairStyleOptions]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <HairStyle
          willingToChange={{
            name: FiltersNameEnum.willingToHairStyle,
            label: filtersLabelOfAudience[FiltersNameEnum.willingToHairStyle],
          }}
          hairStyle={{
            name: FiltersNameEnum.hairStyle,
            label: filtersLabelOfAudience[FiltersNameEnum.hairStyle],
          }}
        />
      </FormItem>
    )
  );
};

export default HairLengthStyleCategory;
